/**
 * Legal copy catalog (Terms + Privacy). Same locale-fallback pattern as
 * data/faq.ts and data/articles.ts. Adds optional `legal-{locale}.json`
 * files when translations land; until then non-EN locales render the EN copy.
 */
import enRaw from '../../../data/legal.json';
import { getLocale } from '../i18n';
import type { Locale } from '../i18n/types';
import type { LegalBanner, LegalDoc } from '@roamzy/shared';

export type { LegalSection, LegalDoc } from '@roamzy/shared';

export interface LegalCatalog {
  draftBanner: LegalBanner;
  terms: LegalDoc;
  privacy: LegalDoc;
}

const localeModules = import.meta.glob<{ default: LegalCatalog }>(
  '../../../data/legal-*.json',
  { eager: true },
);

const byLocale: Partial<Record<Locale, LegalCatalog>> = {
  en: enRaw as unknown as LegalCatalog,
};
for (const [path, mod] of Object.entries(localeModules)) {
  const m = path.match(/legal-([a-z]{2})\.json$/);
  if (m) byLocale[m[1] as Locale] = mod.default;
}

export function getLegal(): LegalCatalog {
  const loc = getLocale();
  return byLocale[loc] ?? (byLocale.en as LegalCatalog);
}
